import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOMeta from '@/components/base/SEOMeta';
import SEOData from '@/components/base/SEOData';
import { categories, comics } from '@/mocks/comics';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find(c => c.slug === slug) || categories[0];
  const [activeSlug, setActiveSlug] = useState(slug || 'remen');

  const filteredComics = activeSlug === 'remen'
    ? comics
    : activeSlug === 'zuixin'
      ? [...comics].sort((a, b) => new Date(b.lastUpdated).getTime() - new Date(a.lastUpdated).getTime())
      : activeSlug === 'wanjie'
        ? comics.filter(c => c.status === '已完结')
        : comics.filter(c => c.category === activeSlug);

  if (slug && slug !== activeSlug) {
    setActiveSlug(slug);
  }

  const catName = currentCategory.name;

  return (
    <>
      <SEOMeta
        title={`${catName} - 免费韩漫${catName} - 韩漫漫画网`}
        description={`韩漫漫画网${catName}专区，提供高清韩国漫画下拉式在线阅读，每日更新热门${catName}漫画，完全免费。`}
        keywords={`${catName},免费韩漫,韩国漫画,高清漫画,韩漫漫画网`}
        canonicalUrl={`http://aetws.cn/category/${slug}`}
      />
      <SEOData type="WebPage" data={{
        name: `${catName} - 韩漫漫画网`,
        url: `http://aetws.cn/category/${slug}`,
        description: `韩漫漫画网${catName}专区，提供高清韩国漫画下拉式在线阅读。`,
        inLanguage: 'zh-CN',
        isPartOf: { '@type': 'WebSite', name: '韩漫漫画网', url: 'http://aetws.cn/' },
      }} />
      <SEOData type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://aetws.cn/' },
          { '@type': 'ListItem', position: 2, name: catName, item: `http://aetws.cn/category/${slug}` },
        ],
      }} />
      <Navbar />
      <main className="pt-20">
        <Breadcrumb items={[{ label: '首页', to: '/' }, { label: catName }]} />

        <section className="w-full py-8 md:py-12 bg-background-50">
          <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              {catName}
            </h1>
            <p className="text-foreground-500 text-sm mb-8">
              共 {filteredComics.length} 部漫画 · 发现你喜欢的韩漫
            </p>

            <div className="flex flex-wrap items-center gap-2 mb-8 p-1 bg-background-100 rounded-full">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setActiveSlug(cat.slug)}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
                {filteredComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-200 flex items-center justify-center">
                  <i className="ri-emotion-sad-line text-foreground-400 text-3xl"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画，请浏览其他分类</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}